import module from '../module';
import * as _ from 'lodash';

function ContactsService($http, cartonomyConfig) {

    const urlBase = `${cartonomyConfig.ApiV2}group`;

    return {
        getContacts: async () => {
            const response = await $http.get(`${urlBase}/contact/all`);
            return response.data;
        },

        getGroups: async () => {
            const response = await $http.get(urlBase);
            return response.data;
        },

        createGroup: function (name, emails) {
            return $http.post(urlBase, {
                name: name,
                groupMembers: _.map(emails, function (email) {
                    return {memberEmail: email};
                })
            });
        },

        updateGroup: function (name, emails) {
            return $http.post(urlBase, {
                name: name,
                groupMembers: _.map(emails, function (email) {
                    return {memberEmail: email};
                })
            });
        },

        getGroup: function (id) {
            return $http.get(`${urlBase}/${id}`).then(function (response) {
                return response.data;
            });
        }
    };
}

module.factory('ContactsService', ['$http', 'cartonomyConfig', ContactsService]);



// WEBPACK FOOTER //
// ./src/modules/shared/services/ContactsService.js